import { Box, CircularProgress, Modal } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { boxStyle } from '../../../constants/types'

import { t } from 'i18next'
import { NotificationManager } from 'react-notifications'
import { useSelector } from 'react-redux'
import trashIcon from '../../../assets/svgs/trash.svg'
import MarketingService from '../../../services/marketingService'
import { identifyVenue, trackEvent } from '../../../utils/mixpanelUtil'

// Translation helper for promotion-related text
export const promotionText = (text) => t(`marketing.promotions.${text}`)

export default function PromotionDeleteModal({ showModal, data, onClose }) {
   const { short_code } = useSelector((state) => state.app)

   const [visible, setVisible] = useState(false)
   const [loading, setLoading] = useState(false)
   const [state, setState] = useState()

   useEffect(() => {
      if (showModal) {
         if (data?.id != null) {
            setState(data)
         }
      }
      setVisible(showModal)
   }, [showModal])

   const onSubmit = () => {
      if (state && state.id) {
         setLoading(true)
         MarketingService.DeletePromotion(state.id)
            .then(({ data }) => {
               identifyVenue(short_code)
               trackEvent('marketing service', {
                  action_category: 'delete',
                  action_outcome: 'success',
                  interaction_element: 'promotions',
               })
               setLoading(false)
               onClose(true)
               NotificationManager.success(
                  data?.message ?? promotionText('promotion_deleted_successfully')
               )
            })
            .catch((err) => {
               identifyVenue(short_code)
               trackEvent('marketing service', {
                  action_category: 'delete',
                  action_outcome: 'fail',
                  interaction_element: 'promotions',
               })
               setLoading(false)
               NotificationManager.error(err?.error ?? t("common.error_generic"))
            })
      }
   }

   return (
      <div>
         <Modal
            open={visible}
            onClose={onClose}
            className="promotion-modal"
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={{ ...boxStyle, width: 400 }} className="outline-none">
               <div className="flex flex-row items-center px-024 pb-016 pt-024 gap-3">
                  <div className="p-2 bg-gray7 rounded-full">
                     <div className="bg-black1 p-2 rounded-full">
                        <img src={trashIcon} alt="icon" />
                     </div>
                  </div>
                  <label className="text-20 font-semibold text-black1">
                     {promotionText('delete_promotion')}
                  </label>
               </div>
               <div>
                  <div className="px-6">
                     <span className="text-gray5 text-sm">
                        {promotionText('confirm_delete_promotion')}
                     </span>
                     <p className="text-gray5 text-sm mt-2">
                        {promotionText('warning_delete_promotion_affects_discounts_coupons')}
                     </p>
                  </div>
               </div>
               <div className="flex flex-row justify-between space-x-4 h-[48px] my-4 px-6">
                  <button
                     className="border border-gray6 rounded-lg font-bold bg-white grow h-full flex justify-center items-center text-cyan1"
                     onClick={onClose}
                  >
                     {t('cancel')}
                  </button>
                  <button
                     className="rounded-lg font-bold bg-red-500 grow h-full flex justify-center items-center text-white"
                     onClick={onSubmit}
                  >
                     {loading ? <CircularProgress size={16} /> : t('delete')}
                  </button>
               </div>
            </Box>
         </Modal>
      </div>
   )
}